import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelSelect as _vModelSelect, vModelDynamic as _vModelDynamic, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["dir"]
const _hoisted_2 = { class: "max-w-6xl mx-auto" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = {
  class: "relative rounded-2xl p-3 shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden w-full",
  style: {"background":"linear-gradient(135deg, #5856d6 0%, #af52de 100%)","box-shadow":"0 8px 32px rgba(88, 86, 214, 0.3),\n              inset 0 1px 0 rgba(255, 255, 255, 0.2)"}
}
const _hoisted_5 = { class: "relative z-10" }
const _hoisted_6 = { class: "flex items-center justify-between" }
const _hoisted_7 = { class: "flex items-center gap-4" }
const _hoisted_8 = { class: "text-2xl font-bold text-white drop-shadow-sm mb-1" }
const _hoisted_9 = { class: "text-white/80 text-sm font-medium" }
const _hoisted_10 = { class: "lg:grid lg:grid-cols-3 gap-6" }
const _hoisted_11 = { class: "lg:col-span-2 space-y-6" }
const _hoisted_12 = {
  key: 0,
  class: "p-4 bg-red-50/80 dark:bg-red-900/20 backdrop-blur-xl rounded-2xl shadow-lg border border-red-200/50 dark:border-red-800/30 mb-6"
}
const _hoisted_13 = { class: "flex items-start gap-4" }
const _hoisted_14 = { class: "text-red-600 dark:text-red-300 mt-1" }
const _hoisted_15 = { class: "bg-white dark:bg-[#1a1a1a] rounded-2xl shadow-lg border border-gray-200/50 dark:border-gray-700/50 p-6 mb-6" }
const _hoisted_16 = { class: "flex items-center gap-3 mb-6" }
const _hoisted_17 = { class: "text-lg font-bold text-gray-900 dark:text-white leading-none h-10 flex items-center" }
const _hoisted_18 = { class: "group" }
const _hoisted_19 = { class: "block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2" }
const _hoisted_20 = { class: "relative" }
const _hoisted_21 = ["placeholder"]
const _hoisted_22 = {
  key: 0,
  class: "absolute top-full left-0 right-0 mt-2 bg-white dark:bg-[#1a1a1a] rounded-2xl shadow-2xl border border-[#E5E7EB] dark:border-[#374151] max-h-60 overflow-y-auto z-50"
}
const _hoisted_23 = {
  key: 0,
  class: "p-4 text-center"
}
const _hoisted_24 = { class: "text-[#666666] dark:text-[#cccccc] mt-2" }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "flex items-center justify-between" }
const _hoisted_28 = { class: "font-semibold text-[#1a1a1a] dark:text-white" }
const _hoisted_29 = { class: "text-sm text-[#666666] dark:text-[#cccccc]" }
const _hoisted_30 = {
  key: 2,
  class: "p-4 text-center text-[#666666] dark:text-[#cccccc]"
}
const _hoisted_31 = {
  key: 0,
  class: "mt-3 p-3 bg-[#F0F9F5] dark:bg-[#0a1a0f] rounded-xl flex items-center justify-between"
}
const _hoisted_32 = { class: "flex items-center gap-3" }
const _hoisted_33 = { class: "font-semibold text-[#1a1a1a] dark:text-white" }
const _hoisted_34 = { class: "text-sm text-[#666666] dark:text-[#cccccc]" }
const _hoisted_35 = {
  key: 1,
  class: "mt-3 text-center"
}
const _hoisted_36 = { class: "text-sm text-[#666666] dark:text-[#cccccc] mb-2" }
const _hoisted_37 = { class: "bg-white dark:bg-[#1a1a1a] rounded-2xl shadow-lg border border-gray-200/50 dark:border-gray-700/50 p-6 mb-6" }
const _hoisted_38 = { class: "flex items-center gap-3 mb-6" }
const _hoisted_39 = { class: "text-lg font-bold text-gray-900 dark:text-white leading-none h-10 flex items-center" }
const _hoisted_40 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6" }
const _hoisted_41 = { class: "md:col-span-2 group" }
const _hoisted_42 = { class: "block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2" }
const _hoisted_43 = { class: "relative" }
const _hoisted_44 = ["placeholder"]
const _hoisted_45 = { class: "group" }
const _hoisted_46 = { class: "block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2" }
const _hoisted_47 = { class: "relative" }
const _hoisted_48 = ["placeholder"]
const _hoisted_49 = { class: "group" }
const _hoisted_50 = { class: "block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2" }
const _hoisted_51 = { class: "relative" }
const _hoisted_52 = { value: "new" }
const _hoisted_53 = { value: "in progress" }
const _hoisted_54 = { value: "on hold" }
const _hoisted_55 = { value: "pending" }
const _hoisted_56 = { value: "negotiation" }
const _hoisted_57 = { value: "closed" }
const _hoisted_58 = { class: "group" }
const _hoisted_59 = { class: "block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2" }
const _hoisted_60 = { class: "relative" }
const _hoisted_61 = { value: "" }
const _hoisted_62 = ["value"]
const _hoisted_63 = { class: "md:col-span-2 group" }
const _hoisted_64 = { class: "block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2" }
const _hoisted_65 = { class: "relative" }
const _hoisted_66 = ["placeholder"]
const _hoisted_67 = {
  key: 1,
  class: "bg-white dark:bg-[#1a1a1a] rounded-2xl shadow-lg border border-gray-200/50 dark:border-gray-700/50 p-6 mb-6"
}
const _hoisted_68 = { class: "flex items-center gap-3 mb-6" }
const _hoisted_69 = { class: "text-lg font-bold text-gray-900 dark:text-white leading-none h-10 flex items-center" }
const _hoisted_70 = {
  key: 0,
  class: "flex justify-center items-center py-8"
}
const _hoisted_71 = {
  key: 1,
  class: "grid grid-cols-1 md:grid-cols-2 gap-6"
}
const _hoisted_72 = { class: "block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2" }
const _hoisted_73 = { class: "material-symbols-outlined text-purple-600 text-sm" }
const _hoisted_74 = { class: "relative" }
const _hoisted_75 = ["type", "onUpdate:modelValue", "required", "placeholder"]
const _hoisted_76 = ["onUpdate:modelValue", "required", "placeholder"]
const _hoisted_77 = {
  key: 2,
  class: "flex items-center pt-2"
}
const _hoisted_78 = ["onUpdate:modelValue", "id"]
const _hoisted_79 = ["for"]
const _hoisted_80 = ["onUpdate:modelValue", "required"]
const _hoisted_81 = { value: "" }
const _hoisted_82 = ["value"]
const _hoisted_83 = {
  key: 4,
  class: "absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none"
}
const _hoisted_84 = { class: "material-symbols-outlined text-gray-400 text-sm" }
const _hoisted_85 = { class: "flex items-center gap-3 mb-6" }
const _hoisted_86 = { class: "text-lg font-bold text-gray-900 dark:text-white leading-none h-10 flex items-center" }
const _hoisted_87 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6" }
const _hoisted_88 = { class: "block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2" }
const _hoisted_89 = { class: "material-symbols-outlined text-purple-600 text-sm" }
const _hoisted_90 = { class: "relative" }
const _hoisted_91 = ["type", "onUpdate:modelValue", "required", "placeholder"]
const _hoisted_92 = ["onUpdate:modelValue", "required", "placeholder"]
const _hoisted_93 = {
  key: 2,
  class: "flex items-center pt-2"
}
const _hoisted_94 = ["onUpdate:modelValue", "id"]
const _hoisted_95 = ["for"]
const _hoisted_96 = ["onUpdate:modelValue", "required"]
const _hoisted_97 = { value: "" }
const _hoisted_98 = ["value"]
const _hoisted_99 = {
  key: 4,
  class: "absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none"
}
const _hoisted_100 = { class: "material-symbols-outlined text-gray-400 text-sm" }
const _hoisted_101 = { class: "bg-white dark:bg-[#1a1a1a] rounded-2xl shadow-lg border border-gray-200/50 dark:border-gray-700/50 p-6 mb-6" }
const _hoisted_102 = { class: "flex items-center gap-3 mb-6" }
const _hoisted_103 = { class: "text-lg font-bold text-gray-900 dark:text-white leading-none h-10 flex items-center" }
const _hoisted_104 = {
  key: 0,
  class: "mb-6 p-4 bg-[#F0F9F5] dark:bg-[#0a1a0f] rounded-2xl border border-[#34C759]/20"
}
const _hoisted_105 = { class: "flex items-center gap-2" }
const _hoisted_106 = { class: "text-sm text-[#666666] dark:text-[#cccccc]" }
const _hoisted_107 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6" }
const _hoisted_108 = { class: "group" }
const _hoisted_109 = { class: "block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2" }
const _hoisted_110 = { class: "relative" }
const _hoisted_111 = ["readonly", "placeholder"]
const _hoisted_112 = { class: "group" }
const _hoisted_113 = { class: "block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2" }
const _hoisted_114 = { class: "relative" }
const _hoisted_115 = ["readonly", "placeholder"]
const _hoisted_116 = {
  key: 2,
  class: "bg-white dark:bg-[#1a1a1a] rounded-2xl shadow-lg border border-gray-200/50 dark:border-gray-700/50 p-6 mb-6"
}
const _hoisted_117 = { class: "flex items-center gap-3 mb-6" }
const _hoisted_118 = { class: "text-lg font-bold text-gray-900 dark:text-white leading-none h-10 flex items-center" }
const _hoisted_119 = { class: "space-y-4" }
const _hoisted_120 = { class: "flex items-start justify-between mb-4" }
const _hoisted_121 = { class: "flex items-start gap-3" }
const _hoisted_122 = {
  key: 0,
  class: "w-16 h-16 rounded-lg overflow-hidden bg-gray-200 dark:bg-gray-700"
}
const _hoisted_123 = ["src", "alt"]
const _hoisted_124 = {
  key: 1,
  class: "w-16 h-16 rounded-lg bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center"
}
const _hoisted_125 = { class: "flex-1 min-w-0" }
const _hoisted_126 = { class: "flex items-center gap-2" }
const _hoisted_127 = { class: "font-semibold text-gray-900 dark:text-white truncate" }
const _hoisted_128 = {
  key: 0,
  class: "px-2 py-1 bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300 text-xs rounded-full font-medium"
}
const _hoisted_129 = {
  key: 0,
  class: "text-sm text-gray-600 dark:text-gray-400 mt-1 line-clamp-2 overflow-hidden"
}
const _hoisted_130 = { class: "flex items-center gap-4 mt-2" }
const _hoisted_131 = { class: "text-lg font-bold text-purple-600" }
const _hoisted_132 = {
  key: 0,
  class: "text-sm text-gray-500 line-through"
}
const _hoisted_133 = ["onClick"]
const _hoisted_134 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_135 = { class: "block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2" }
const _hoisted_136 = ["onUpdate:modelValue"]
const _hoisted_137 = { key: 0 }
const _hoisted_138 = { class: "block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2" }
const _hoisted_139 = ["onUpdate:modelValue"]
const _hoisted_140 = { value: "" }
const _hoisted_141 = ["value"]
const _hoisted_142 = {
  key: 0,
  class: "mt-4 pt-4 border-t border-gray-200 dark:border-gray-600"
}
const _hoisted_143 = { class: "text-sm font-semibold text-gray-800 dark:text-gray-200 mb-3" }
const _hoisted_144 = { class: "grid grid-cols-1 md:grid-cols-2 gap-3" }
const _hoisted_145 = { class: "block text-xs font-medium text-gray-700 dark:text-gray-300" }
const _hoisted_146 = ["type", "onUpdate:modelValue", "placeholder"]
const _hoisted_147 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_148 = ["onUpdate:modelValue"]
const _hoisted_149 = { value: "" }
const _hoisted_150 = ["value"]
const _hoisted_151 = { class: "col-span-full mb-2" }
const _hoisted_152 = { class: "text-sm font-medium text-gray-800 dark:text-gray-200" }
const _hoisted_153 = { class: "block text-xs font-medium text-gray-700 dark:text-gray-300" }
const _hoisted_154 = ["type", "onUpdate:modelValue", "placeholder"]
const _hoisted_155 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_156 = ["onUpdate:modelValue"]
const _hoisted_157 = { value: "" }
const _hoisted_158 = ["value"]
const _hoisted_159 = {
  key: 1,
  class: "text-xs text-red-500"
}
const _hoisted_160 = { class: "lg:hidden bg-white dark:bg-[#1a1a1a] rounded-2xl shadow-lg border border-gray-200/50 dark:border-gray-700/50 p-6" }
const _hoisted_161 = { class: "flex items-center gap-3 mb-6" }
const _hoisted_162 = { class: "text-lg font-bold text-gray-900 dark:text-white leading-none h-10 flex items-center" }
const _hoisted_163 = { class: "space-y-4" }
const _hoisted_164 = ["disabled"]
const _hoisted_165 = {
  key: 0,
  class: "inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"
}
const _hoisted_166 = {
  key: 1,
  class: "material-symbols-outlined text-lg"
}
const _hoisted_167 = { class: "hidden lg:block lg:col-span-1" }
const _hoisted_168 = { class: "flex items-center gap-3 mb-6" }
const _hoisted_169 = { class: "text-lg font-bold text-gray-900 dark:text-white leading-none h-10 flex items-center" }
const _hoisted_170 = { class: "space-y-4" }
const _hoisted_171 = ["disabled"]
const _hoisted_172 = {
  key: 0,
  class: "inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"
}
const _hoisted_173 = {
  key: 1,
  class: "material-symbols-outlined text-lg"
}
const _hoisted_174 = {
  key: 0,
  class: "fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4"
}
const _hoisted_175 = { class: "bg-white dark:bg-[#1a1a1a] rounded-2xl shadow-2xl border border-gray-200/50 dark:border-gray-700/50 w-full max-w-4xl max-h-[80vh] overflow-hidden mt-[100px] sm:mt-0 flex flex-col" }
const _hoisted_176 = { class: "flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700 flex-shrink-0" }
const _hoisted_177 = { class: "flex items-center gap-3" }
const _hoisted_178 = { class: "text-lg font-bold text-gray-900 dark:text-white" }
const _hoisted_179 = { class: "text-sm text-gray-600 dark:text-gray-400" }
const _hoisted_180 = { class: "p-6 border-b border-gray-200 dark:border-gray-700 flex-shrink-0" }
const _hoisted_181 = { class: "relative" }
const _hoisted_182 = ["placeholder"]
const _hoisted_183 = { class: "flex-1 overflow-y-auto min-h-0" }
const _hoisted_184 = {
  key: 0,
  class: "flex items-center justify-center py-12"
}
const _hoisted_185 = { class: "text-center" }
const _hoisted_186 = { class: "text-gray-600 dark:text-gray-400" }
const _hoisted_187 = {
  key: 1,
  class: "flex items-center justify-center py-12"
}
const _hoisted_188 = { class: "text-center" }
const _hoisted_189 = { class: "text-gray-600 dark:text-gray-400" }
const _hoisted_190 = {
  key: 2,
  class: "p-6 grid grid-cols-1 md:grid-cols-2 gap-4 pb-4"
}
const _hoisted_191 = ["onClick"]
const _hoisted_192 = { class: "flex items-start gap-3" }
const _hoisted_193 = { class: "w-16 h-16 rounded-lg overflow-hidden bg-gray-200 dark:bg-gray-700 flex-shrink-0" }
const _hoisted_194 = ["src", "alt"]
const _hoisted_195 = {
  key: 1,
  class: "w-full h-full bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center"
}
const _hoisted_196 = { class: "flex-1 min-w-0" }
const _hoisted_197 = { class: "flex items-start justify-between" }
const _hoisted_198 = { class: "flex-1 min-w-0" }
const _hoisted_199 = { class: "font-semibold text-gray-900 dark:text-white truncate" }
const _hoisted_200 = {
  key: 0,
  class: "text-sm text-gray-600 dark:text-gray-400 mt-1 line-clamp-2 overflow-hidden"
}
const _hoisted_201 = { class: "flex items-center gap-2 mt-2" }
const _hoisted_202 = { class: "text-lg font-bold text-purple-600" }
const _hoisted_203 = {
  key: 0,
  class: "text-sm text-gray-500 line-through"
}
const _hoisted_204 = { class: "flex items-center gap-4 mt-2 text-xs text-gray-500 dark:text-gray-400" }
const _hoisted_205 = {
  key: 0,
  class: "flex items-center gap-1"
}
const _hoisted_206 = {
  key: 1,
  class: "flex items-center gap-1"
}
const _hoisted_207 = {
  key: 2,
  class: "flex items-center gap-1"
}
const _hoisted_208 = {
  key: 1,
  class: "mt-3 pt-3 border-t border-gray-200 dark:border-gray-600"
}
const _hoisted_209 = { class: "block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2" }
const _hoisted_210 = { class: "flex items-center gap-2" }
const _hoisted_211 = ["onClick"]
const _hoisted_212 = ["value", "onInput"]
const _hoisted_213 = ["onClick"]
const _hoisted_214 = { class: "text-xs text-gray-500 dark:text-gray-400 mt-1" }
const _hoisted_215 = { class: "flex-shrink-0 ml-3" }
const _hoisted_216 = {
  key: 0,
  class: "material-symbols-outlined text-white text-sm"
}
const _hoisted_217 = { class: "flex-shrink-0 border-t border-gray-200 dark:border-gray-700 bg-white dark:bg-[#1a1a1a]" }
const _hoisted_218 = { class: "flex items-center justify-between p-4 sm:p-6" }
const _hoisted_219 = { class: "text-sm text-gray-600 dark:text-gray-400" }
const _hoisted_220 = { class: "flex items-center gap-3" }
const _hoisted_221 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "min-h-screen bg-white dark:bg-[#0c1427] p-3",
      dir: _ctx.isRtl ? 'rtl' : 'ltr'
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[21] || (_cache[21] = _createElementVNode("div", { class: "absolute inset-0 overflow-hidden" }, [
              _createElementVNode("div", {
                class: "absolute -top-20 -right-20 w-40 h-40 rounded-full opacity-20",
                style: {"background":"radial-gradient(\n                  circle,\n                  rgba(255, 255, 255, 0.3) 0%,\n                  transparent 70%\n                )"}
              }),
              _createElementVNode("div", {
                class: "absolute -bottom-16 -left-16 w-32 h-32 rounded-full opacity-15",
                style: {"background":"radial-gradient(\n                  circle,\n                  rgba(255, 255, 255, 0.4) 0%,\n                  transparent 70%\n                )"}
              })
            ], -1)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[20] || (_cache[20] = _createElementVNode("div", { class: "relative flex-shrink-0" }, [
                    _createElementVNode("div", { class: "w-20 h-20 rounded-full bg-white/20 backdrop-blur-sm border-3 border-white/70 shadow-xl flex items-center justify-center" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined text-white text-3xl" }, "handshake")
                    ])
                  ], -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.directT('crm.deals.form.title')), 1),
                    _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.directT('crm.deals.form.subtitle')), 1)
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("form", {
          onSubmit: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveDeal && _ctx.saveDeal(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              (_ctx.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _cache[23] || (_cache[23] = _createElementVNode("div", { class: "w-10 h-10 bg-red-500/10 rounded-xl flex items-center justify-center" }, [
                        _createElementVNode("i", { class: "material-symbols-outlined text-red-500 text-xl" }, "error")
                      ], -1)),
                      _createElementVNode("div", null, [
                        _cache[22] || (_cache[22] = _createElementVNode("h3", { class: "text-lg font-semibold text-red-700 dark:text-red-400" }, "שגיאה", -1)),
                        _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.error), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _cache[24] || (_cache[24] = _createElementVNode("div", { class: "w-10 h-10 bg-gradient-to-br from-[#5856d6] to-[#af52de] rounded-xl flex items-center justify-center" }, [
                    _createElementVNode("i", { class: "material-symbols-outlined text-white text-lg" }, "person")
                  ], -1)),
                  _createElementVNode("h3", _hoisted_17, _toDisplayString(_ctx.directT('crm.deals.form.selectClient') || 'בחר לקוח'), 1)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("label", _hoisted_19, [
                    _cache[25] || (_cache[25] = _createElementVNode("i", { class: "material-symbols-outlined text-purple-600 text-sm" }, "search", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.directT('crm.deals.form.searchClient') || 'חפש לקוח קיים'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.clientSearchTerm) = $event)),
                      type: "text",
                      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.searchClients && _ctx.searchClients(...args))),
                      onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showClientDropdown = true)),
                      onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleSearchBlur && _ctx.handleSearchBlur(...args))),
                      class: "w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400",
                      placeholder: _ctx.directT('crm.deals.form.searchClientPlaceholder') || 'חפש לפי שם או טלפון...'
                    }, null, 40, _hoisted_21), [
                      [_vModelText, _ctx.clientSearchTerm]
                    ]),
                    _cache[28] || (_cache[28] = _createElementVNode("div", { class: "absolute right-3 top-1/2 -translate-y-1/2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined text-gray-400 text-sm" }, "search")
                    ], -1)),
                    (_ctx.showClientDropdown && (_ctx.searchingClients || _ctx.filteredClients.length > 0))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          (_ctx.searchingClients)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                _cache[26] || (_cache[26] = _createElementVNode("div", { class: "inline-block w-5 h-5 border-2 border-[#34C759] border-t-transparent rounded-full animate-spin" }, null, -1)),
                                _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.directT('crm.deals.form.searching') || 'מחפש...'), 1)
                              ]))
                            : (_ctx.filteredClients.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredClients, (client) => {
                                    return (_openBlock(), _createElementBlock("button", {
                                      key: client.id,
                                      type: "button",
                                      onClick: ($event: any) => (_ctx.selectClient(client)),
                                      class: "w-full px-4 py-3 hover:bg-[#F0F9F5] dark:hover:bg-[#0a1a0f] transition-colors text-left border-b border-[#E5E7EB] dark:border-[#374151] last:border-0"
                                    }, [
                                      _createElementVNode("div", _hoisted_27, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.getClientFullName(client)), 1),
                                          _createElementVNode("p", _hoisted_29, _toDisplayString(client.phone || 'אין טלפון'), 1)
                                        ]),
                                        _cache[27] || (_cache[27] = _createElementVNode("i", { class: "ri-arrow-left-s-line text-[#34C759]" }, null, -1))
                                      ])
                                    ], 8, _hoisted_26))
                                  }), 128))
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_ctx.directT('crm.deals.form.noClientsFound') || 'לא נמצאו לקוחות'), 1))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.selectedClient)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _cache[29] || (_cache[29] = _createElementVNode("div", { class: "w-10 h-10 bg-[#34C759] rounded-xl flex items-center justify-center" }, [
                            _createElementVNode("i", { class: "ri-user-3-fill text-white" })
                          ], -1)),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.getClientFullName(_ctx.selectedClient)), 1),
                            _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.selectedClient.phone || 'אין טלפון'), 1)
                          ])
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clearSelectedClient && _ctx.clearSelectedClient(...args))),
                          class: "p-2 hover:bg-[#34C759]/10 rounded-lg transition-colors"
                        }, _cache[30] || (_cache[30] = [
                          _createElementVNode("i", { class: "ri-close-line text-[#666666] dark:text-[#cccccc]" }, null, -1)
                        ]))
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.selectedClient)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.directT('crm.deals.form.clientNotFound') || 'לא מצאת את הלקוח?'), 1),
                        _createVNode(_component_router_link, {
                          to: "/crm/customers",
                          class: "inline-flex items-center gap-2 text-[#5856d6] hover:text-[#af52de] font-medium text-sm transition-colors underline"
                        }, {
                          default: _withCtx(() => [
                            _cache[31] || (_cache[31] = _createElementVNode("i", { class: "ri-user-add-line" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.directT('crm.deals.form.createNewClient') || 'צור לקוח חדש'), 1)
                          ]),
                          _: 1,
                          __: [31]
                        })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _cache[32] || (_cache[32] = _createElementVNode("div", { class: "w-10 h-10 bg-gradient-to-br from-[#5856d6] to-[#af52de] rounded-xl flex items-center justify-center" }, [
                    _createElementVNode("i", { class: "material-symbols-outlined text-white text-lg" }, "description")
                  ], -1)),
                  _createElementVNode("h3", _hoisted_39, _toDisplayString(_ctx.directT('crm.deals.form.dealInformation')), 1)
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("label", _hoisted_42, [
                      _cache[33] || (_cache[33] = _createElementVNode("i", { class: "material-symbols-outlined text-purple-600 text-sm" }, "title", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.directT('crm.deals.form.dealTitle')) + " ", 1),
                      _cache[34] || (_cache[34] = _createElementVNode("span", { class: "text-red-500" }, "*", -1))
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newDeal.title) = $event)),
                        type: "text",
                        required: "",
                        placeholder: _ctx.directT('crm.deals.form.dealTitlePlaceholder'),
                        class: "w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                      }, null, 8, _hoisted_44), [
                        [_vModelText, _ctx.newDeal.title]
                      ]),
                      _cache[35] || (_cache[35] = _createElementVNode("div", { class: "absolute right-3 top-1/2 -translate-y-1/2" }, [
                        _createElementVNode("i", { class: "material-symbols-outlined text-gray-400 text-sm" }, "edit")
                      ], -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("label", _hoisted_46, [
                      _cache[36] || (_cache[36] = _createElementVNode("i", { class: "material-symbols-outlined text-purple-600 text-sm" }, "payments", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.directT('crm.deals.form.amount')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newDeal.amount) = $event)),
                        type: "number",
                        step: "0.01",
                        placeholder: _ctx.directT('crm.deals.form.amountPlaceholder'),
                        class: "w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                      }, null, 8, _hoisted_48), [
                        [_vModelText, _ctx.newDeal.amount]
                      ]),
                      _cache[37] || (_cache[37] = _createElementVNode("div", { class: "absolute right-3 top-1/2 -translate-y-1/2" }, [
                        _createElementVNode("i", { class: "material-symbols-outlined text-gray-400 text-sm" }, "attach_money")
                      ], -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("label", _hoisted_50, [
                      _cache[38] || (_cache[38] = _createElementVNode("i", { class: "material-symbols-outlined text-purple-600 text-sm" }, "flag", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.directT('crm.deals.form.status')) + " ", 1),
                      _cache[39] || (_cache[39] = _createElementVNode("span", { class: "text-red-500" }, "*", -1))
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newDeal.status) = $event)),
                        required: "",
                        class: "w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white cursor-pointer appearance-none"
                      }, [
                        _createElementVNode("option", _hoisted_52, _toDisplayString(_ctx.directT('crm.deals.form.statusOptions.new')), 1),
                        _createElementVNode("option", _hoisted_53, _toDisplayString(_ctx.directT('crm.deals.form.statusOptions.inProgress')), 1),
                        _createElementVNode("option", _hoisted_54, _toDisplayString(_ctx.directT('crm.deals.form.statusOptions.onHold')), 1),
                        _createElementVNode("option", _hoisted_55, _toDisplayString(_ctx.directT('crm.deals.form.statusOptions.pending')), 1),
                        _createElementVNode("option", _hoisted_56, _toDisplayString(_ctx.directT('crm.deals.form.statusOptions.negotiation')), 1),
                        _createElementVNode("option", _hoisted_57, _toDisplayString(_ctx.directT('crm.deals.form.statusOptions.closed')), 1)
                      ], 512), [
                        [_vModelSelect, _ctx.newDeal.status]
                      ]),
                      _cache[40] || (_cache[40] = _createElementVNode("div", { class: "absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none" }, [
                        _createElementVNode("i", { class: "material-symbols-outlined text-gray-400 text-sm" }, "expand_more")
                      ], -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("label", _hoisted_59, [
                      _cache[41] || (_cache[41] = _createElementVNode("i", { class: "material-symbols-outlined text-purple-600 text-sm" }, "person_check", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.directT('crm.deals.form.closedBy') || 'נסגר על ידי'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newDeal.closed_by) = $event)),
                        class: "w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white cursor-pointer appearance-none"
                      }, [
                        _createElementVNode("option", _hoisted_61, _toDisplayString(_ctx.directT('crm.deals.form.selectUser') || 'בחר משתמש'), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: user.user_id,
                            value: user.user_id
                          }, _toDisplayString(user.display_name || user.email), 9, _hoisted_62))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.newDeal.closed_by]
                      ]),
                      _cache[42] || (_cache[42] = _createElementVNode("div", { class: "absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none" }, [
                        _createElementVNode("i", { class: "material-symbols-outlined text-gray-400 text-sm" }, "expand_more")
                      ], -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_63, [
                    _createElementVNode("label", _hoisted_64, [
                      _cache[43] || (_cache[43] = _createElementVNode("i", { class: "material-symbols-outlined text-purple-600 text-sm" }, "description", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.directT('crm.deals.form.description')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_65, [
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newDeal.description) = $event)),
                        rows: "4",
                        class: "w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 resize-none",
                        placeholder: _ctx.directT('crm.deals.form.descriptionPlaceholder')
                      }, null, 8, _hoisted_66), [
                        [_vModelText, _ctx.newDeal.description]
                      ]),
                      _cache[44] || (_cache[44] = _createElementVNode("div", { class: "absolute right-3 top-3" }, [
                        _createElementVNode("i", { class: "material-symbols-outlined text-gray-400 text-sm" }, "edit")
                      ], -1))
                    ])
                  ])
                ])
              ]),
              (_ctx.customFields.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                    _createElementVNode("div", _hoisted_68, [
                      _cache[45] || (_cache[45] = _createElementVNode("div", { class: "w-10 h-10 bg-gradient-to-br from-[#5856d6] to-[#af52de] rounded-xl flex items-center justify-center" }, [
                        _createElementVNode("i", { class: "material-symbols-outlined text-white text-lg" }, "tune")
                      ], -1)),
                      _createElementVNode("h3", _hoisted_69, _toDisplayString(_ctx.directT('crm.deals.form.customFields') || 'שדות מותאמים אישית'), 1)
                    ]),
                    (_ctx.loadingCustomFields)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_70, _cache[46] || (_cache[46] = [
                          _createElementVNode("div", { class: "animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-purple-500" }, null, -1)
                        ])))
                      : (_openBlock(), _createElementBlock("div", _hoisted_71, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customFields, (field) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: field.key,
                              class: _normalizeClass([{'md:col-span-2': field.type === 'textarea'}, "group"])
                            }, [
                              _createElementVNode("label", _hoisted_72, [
                                _createElementVNode("i", _hoisted_73, _toDisplayString(field.type === 'text' ? 'text_fields' : 
                            field.type === 'number' ? 'numbers' :
                            field.type === 'email' ? 'email' :
                            field.type === 'phone' ? 'phone' :
                            field.type === 'date' ? 'calendar_today' :
                            field.type === 'select' ? 'arrow_drop_down' :
                            field.type === 'textarea' ? 'notes' :
                            'text_fields'), 1),
                                _createTextVNode(" " + _toDisplayString(field.label) + _toDisplayString(field.required ? ' *' : ''), 1)
                              ]),
                              _createElementVNode("div", _hoisted_74, [
                                (_ctx.getInputType(field.type) !== 'select' && field.type !== 'textarea' && field.type !== 'checkbox')
                                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                      key: 0,
                                      type: _ctx.getInputType(field.type),
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.customFieldValues[field.key]) = $event),
                                      required: field.required,
                                      placeholder: field.placeholder || '',
                                      class: "w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                                    }, null, 8, _hoisted_75)), [
                                      [_vModelDynamic, _ctx.customFieldValues[field.key]]
                                    ])
                                  : (field.type === 'textarea')
                                    ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                        key: 1,
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.customFieldValues[field.key]) = $event),
                                        required: field.required,
                                        placeholder: field.placeholder || '',
                                        rows: "3",
                                        class: "w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 resize-none"
                                      }, null, 8, _hoisted_76)), [
                                        [_vModelText, _ctx.customFieldValues[field.key]]
                                      ])
                                    : (field.type === 'checkbox')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "checkbox",
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.customFieldValues[field.key]) = $event),
                                            id: `custom-field-${field.key}`,
                                            class: "w-5 h-5 text-purple-600 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded focus:ring-purple-500/20 focus:ring-2"
                                          }, null, 8, _hoisted_78), [
                                            [_vModelCheckbox, _ctx.customFieldValues[field.key]]
                                          ]),
                                          _createElementVNode("label", {
                                            for: `custom-field-${field.key}`,
                                            class: "ml-3 text-sm text-gray-900 dark:text-white"
                                          }, _toDisplayString(field.placeholder || field.label), 9, _hoisted_79)
                                        ]))
                                      : _withDirectives((_openBlock(), _createElementBlock("select", {
                                          key: 3,
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.customFieldValues[field.key]) = $event),
                                          required: field.required,
                                          class: "w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white cursor-pointer appearance-none"
                                        }, [
                                          _createElementVNode("option", _hoisted_81, _toDisplayString(_ctx.directT('crm.deals.form.selectOption') || 'בחר אפשרות'), 1),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.options, (option) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                              key: option,
                                              value: option
                                            }, _toDisplayString(option), 9, _hoisted_82))
                                          }), 128))
                                        ], 8, _hoisted_80)), [
                                          [_vModelSelect, _ctx.customFieldValues[field.key]]
                                        ]),
                                (field.type !== 'checkbox' && field.type !== 'textarea')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                                      _createElementVNode("i", _hoisted_84, _toDisplayString(field.type === 'select' ? 'expand_more' : 'edit'), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ], 2))
                          }), 128))
                        ]))
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.systemAreas, (area) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: area.id,
                  class: "bg-white dark:bg-[#1a1a1a] rounded-2xl shadow-lg border border-gray-200/50 dark:border-gray-700/50 p-6 mb-6"
                }, [
                  _createElementVNode("div", _hoisted_85, [
                    _cache[47] || (_cache[47] = _createElementVNode("div", { class: "w-10 h-10 bg-gradient-to-br from-[#5856d6] to-[#af52de] rounded-xl flex items-center justify-center" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined text-white text-lg" }, "dashboard")
                    ], -1)),
                    _createElementVNode("h3", _hoisted_86, _toDisplayString(area.title), 1)
                  ]),
                  _createElementVNode("div", _hoisted_87, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(area.fields, (field) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: field.key,
                        class: _normalizeClass([{'md:col-span-2': field.type === 'textarea'}, "group"])
                      }, [
                        _createElementVNode("label", _hoisted_88, [
                          _createElementVNode("i", _hoisted_89, _toDisplayString(field.type === 'text' ? 'text_fields' : 
                              field.type === 'number' ? 'numbers' :
                              field.type === 'email' ? 'email' :
                              field.type === 'phone' ? 'phone' :
                              field.type === 'date' ? 'calendar_today' :
                              field.type === 'select' ? 'arrow_drop_down' :
                              field.type === 'textarea' ? 'notes' :
                              'text_fields'), 1),
                          _createTextVNode(" " + _toDisplayString(field.label) + _toDisplayString(field.required ? ' *' : ''), 1)
                        ]),
                        _createElementVNode("div", _hoisted_90, [
                          (_ctx.getInputType(field.type) !== 'select' && field.type !== 'textarea' && field.type !== 'checkbox')
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 0,
                                type: _ctx.getInputType(field.type),
                                "onUpdate:modelValue": ($event: any) => ((_ctx.customFieldValues[field.key]) = $event),
                                required: field.required,
                                placeholder: field.placeholder || '',
                                class: "w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                              }, null, 8, _hoisted_91)), [
                                [_vModelDynamic, _ctx.customFieldValues[field.key]]
                              ])
                            : (field.type === 'textarea')
                              ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                  key: 1,
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.customFieldValues[field.key]) = $event),
                                  required: field.required,
                                  placeholder: field.placeholder || '',
                                  rows: "3",
                                  class: "w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 resize-none"
                                }, null, 8, _hoisted_92)), [
                                  [_vModelText, _ctx.customFieldValues[field.key]]
                                ])
                              : (field.type === 'checkbox')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "checkbox",
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.customFieldValues[field.key]) = $event),
                                      id: `area-field-${field.key}`,
                                      class: "w-5 h-5 text-purple-600 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded focus:ring-purple-500/20 focus:ring-2"
                                    }, null, 8, _hoisted_94), [
                                      [_vModelCheckbox, _ctx.customFieldValues[field.key]]
                                    ]),
                                    _createElementVNode("label", {
                                      for: `area-field-${field.key}`,
                                      class: "ml-3 text-sm text-gray-900 dark:text-white"
                                    }, _toDisplayString(field.placeholder || field.label), 9, _hoisted_95)
                                  ]))
                                : _withDirectives((_openBlock(), _createElementBlock("select", {
                                    key: 3,
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.customFieldValues[field.key]) = $event),
                                    required: field.required,
                                    class: "w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white cursor-pointer appearance-none"
                                  }, [
                                    _createElementVNode("option", _hoisted_97, _toDisplayString(_ctx.directT('crm.deals.form.selectOption') || 'בחר אפשרות'), 1),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.options, (option) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: option,
                                        value: option
                                      }, _toDisplayString(option), 9, _hoisted_98))
                                    }), 128))
                                  ], 8, _hoisted_96)), [
                                    [_vModelSelect, _ctx.customFieldValues[field.key]]
                                  ]),
                          (field.type !== 'checkbox' && field.type !== 'textarea')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                                _createElementVNode("i", _hoisted_100, _toDisplayString(field.type === 'select' ? 'expand_more' : 'edit'), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ], 2))
                    }), 128))
                  ])
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_101, [
                _createElementVNode("div", _hoisted_102, [
                  _cache[48] || (_cache[48] = _createElementVNode("div", { class: "w-10 h-10 bg-gradient-to-br from-[#5856d6] to-[#af52de] rounded-xl flex items-center justify-center" }, [
                    _createElementVNode("i", { class: "material-symbols-outlined text-white text-lg" }, "contacts")
                  ], -1)),
                  _createElementVNode("h3", _hoisted_103, _toDisplayString(_ctx.directT('crm.deals.form.contactInformation')), 1)
                ]),
                (_ctx.selectedClient)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                      _createElementVNode("div", _hoisted_105, [
                        _cache[49] || (_cache[49] = _createElementVNode("i", { class: "ri-information-line text-[#34C759]" }, null, -1)),
                        _createElementVNode("p", _hoisted_106, _toDisplayString(_ctx.directT('crm.deals.form.autoFilledInfo') || 'השדות למטה מולאו אוטומטית מפרטי הלקוח שנבחר'), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_107, [
                  _createElementVNode("div", _hoisted_108, [
                    _createElementVNode("label", _hoisted_109, [
                      _cache[50] || (_cache[50] = _createElementVNode("i", { class: "material-symbols-outlined text-purple-600 text-sm" }, "person", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.directT('crm.deals.form.contactPerson')) + " ", 1),
                      _cache[51] || (_cache[51] = _createElementVNode("span", { class: "text-red-500" }, "*", -1))
                    ]),
                    _createElementVNode("div", _hoisted_110, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newDeal.name) = $event)),
                        type: "text",
                        required: "",
                        readonly: !!_ctx.selectedClient,
                        placeholder: _ctx.directT('crm.deals.form.contactPersonPlaceholder'),
                        class: _normalizeClass(["w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400", _ctx.selectedClient ? 'bg-gray-100 dark:bg-gray-800 cursor-not-allowed' : ''])
                      }, null, 10, _hoisted_111), [
                        [_vModelText, _ctx.newDeal.name]
                      ]),
                      _cache[52] || (_cache[52] = _createElementVNode("div", { class: "absolute right-3 top-1/2 -translate-y-1/2" }, [
                        _createElementVNode("i", { class: "material-symbols-outlined text-gray-400 text-sm" }, "edit")
                      ], -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_112, [
                    _createElementVNode("label", _hoisted_113, [
                      _cache[53] || (_cache[53] = _createElementVNode("i", { class: "material-symbols-outlined text-purple-600 text-sm" }, "phone", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.directT('crm.deals.form.phone')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_114, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.newDeal.phone) = $event)),
                        type: "tel",
                        readonly: !!_ctx.selectedClient,
                        placeholder: _ctx.directT('crm.deals.form.phonePlaceholder'),
                        class: _normalizeClass(["w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400", _ctx.selectedClient ? 'bg-gray-100 dark:bg-gray-800 cursor-not-allowed' : ''])
                      }, null, 10, _hoisted_115), [
                        [_vModelText, _ctx.newDeal.phone]
                      ]),
                      _cache[54] || (_cache[54] = _createElementVNode("div", { class: "absolute right-3 top-1/2 -translate-y-1/2" }, [
                        _createElementVNode("i", { class: "material-symbols-outlined text-gray-400 text-sm" }, "phone")
                      ], -1))
                    ])
                  ])
                ])
              ]),
              (_ctx.dealProducts.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                    _createElementVNode("div", _hoisted_117, [
                      _cache[55] || (_cache[55] = _createElementVNode("div", { class: "w-10 h-10 bg-gradient-to-br from-[#5856d6] to-[#af52de] rounded-xl flex items-center justify-center" }, [
                        _createElementVNode("i", { class: "material-symbols-outlined text-white text-lg" }, "inventory")
                      ], -1)),
                      _createElementVNode("h3", _hoisted_118, _toDisplayString(_ctx.directT('crm.deals.form.productsInDeal', { count: _ctx.dealProducts.length })), 1)
                    ]),
                    _createElementVNode("div", _hoisted_119, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dealProducts, (dealProduct) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: dealProduct.id,
                          class: "bg-gray-50 dark:bg-gray-800/50 rounded-xl p-4 border border-gray-200 dark:border-gray-700"
                        }, [
                          _createElementVNode("div", _hoisted_120, [
                            _createElementVNode("div", _hoisted_121, [
                              (dealProduct.imageLink)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                                    _createElementVNode("img", {
                                      src: dealProduct.imageLink,
                                      alt: dealProduct.title,
                                      class: "w-full h-full object-cover"
                                    }, null, 8, _hoisted_123)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_124, _cache[56] || (_cache[56] = [
                                    _createElementVNode("i", { class: "material-symbols-outlined text-white text-xl" }, "inventory", -1)
                                  ]))),
                              _createElementVNode("div", _hoisted_125, [
                                _createElementVNode("div", _hoisted_126, [
                                  _createElementVNode("h4", _hoisted_127, _toDisplayString(dealProduct.title), 1),
                                  (dealProduct.totalCards && dealProduct.totalCards > 1)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_128, _toDisplayString(dealProduct.cardNumber) + "/" + _toDisplayString(dealProduct.totalCards), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                (dealProduct.description)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_129, _toDisplayString(dealProduct.description), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_130, [
                                  _createElementVNode("span", _hoisted_131, _toDisplayString(_ctx.currencySymbol) + _toDisplayString(dealProduct.price), 1),
                                  (dealProduct.compareAtPrice && dealProduct.compareAtPrice > dealProduct.price)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_132, _toDisplayString(_ctx.currencySymbol) + _toDisplayString(dealProduct.compareAtPrice), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (_ctx.removeProductFromDeal(dealProduct.id)),
                              class: "p-2 text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors"
                            }, _cache[57] || (_cache[57] = [
                              _createElementVNode("i", { class: "material-symbols-outlined text-lg" }, "delete", -1)
                            ]), 8, _hoisted_133)
                          ]),
                          _createElementVNode("div", _hoisted_134, [
                            _createElementVNode("div", null, [
                              _createElementVNode("label", _hoisted_135, _toDisplayString(_ctx.directT('crm.deals.form.quantity')), 1),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((dealProduct.quantity) = $event),
                                type: "number",
                                min: "1",
                                class: "w-full px-3 py-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm"
                              }, null, 8, _hoisted_136), [
                                [
                                  _vModelText,
                                  dealProduct.quantity,
                                  void 0,
                                  { number: true }
                                ]
                              ])
                            ]),
                            (dealProduct.variations.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                                  _createElementVNode("label", _hoisted_138, _toDisplayString(_ctx.getVariationGroupTitle(dealProduct.variations)), 1),
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": ($event: any) => ((dealProduct.selectedVariation) = $event),
                                    class: "w-full px-3 py-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm"
                                  }, [
                                    _createElementVNode("option", _hoisted_140, _toDisplayString(_ctx.getVariationPlaceholder(dealProduct.variations)), 1),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dealProduct.variations, (variation) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: variation.id,
                                        value: variation
                                      }, _toDisplayString(_ctx.getVariationOptionText(variation, dealProduct.price)), 9, _hoisted_141))
                                    }), 128))
                                  ], 8, _hoisted_139), [
                                    [_vModelSelect, dealProduct.selectedVariation]
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          (dealProduct.customFields && dealProduct.customFields.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                                _createElementVNode("h5", _hoisted_143, _toDisplayString(_ctx.directT('crm.deals.form.productCustomFields')), 1),
                                _createElementVNode("div", _hoisted_144, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dealProduct.customFields, (customField) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, {
                                      key: customField.id
                                    }, [
                                      (customField.content)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            (Array.isArray(customField.content))
                                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(customField.content, (field) => {
                                                  return (_openBlock(), _createElementBlock("div", {
                                                    key: field.key || field.id,
                                                    class: "space-y-1"
                                                  }, [
                                                    _createElementVNode("label", _hoisted_145, _toDisplayString(field.label) + _toDisplayString(field.required ? ' *' : ''), 1),
                                                    (field.type !== 'select' && field.type !== 'textarea')
                                                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                          key: 0,
                                                          type: _ctx.getInputType(field.type),
                                                          "onUpdate:modelValue": ($event: any) => ((dealProduct.customFieldValues[field.key || field.id]) = $event),
                                                          placeholder: field.placeholder || '',
                                                          class: "w-full px-3 py-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm"
                                                        }, null, 8, _hoisted_146)), [
                                                          [_vModelDynamic, dealProduct.customFieldValues[field.key || field.id]]
                                                        ])
                                                      : (field.type === 'textarea')
                                                        ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                                            key: 1,
                                                            "onUpdate:modelValue": ($event: any) => ((dealProduct.customFieldValues[field.key || field.id]) = $event),
                                                            placeholder: field.placeholder || '',
                                                            rows: "2",
                                                            class: "w-full px-3 py-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm resize-none"
                                                          }, null, 8, _hoisted_147)), [
                                                            [_vModelText, dealProduct.customFieldValues[field.key || field.id]]
                                                          ])
                                                        : _withDirectives((_openBlock(), _createElementBlock("select", {
                                                            key: 2,
                                                            "onUpdate:modelValue": ($event: any) => ((dealProduct.customFieldValues[field.key || field.id]) = $event),
                                                            class: "w-full px-3 py-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm"
                                                          }, [
                                                            _createElementVNode("option", _hoisted_149, _toDisplayString(_ctx.directT('crm.deals.form.selectOption')), 1),
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.options, (option) => {
                                                              return (_openBlock(), _createElementBlock("option", {
                                                                key: option,
                                                                value: option
                                                              }, _toDisplayString(option), 9, _hoisted_150))
                                                            }), 128))
                                                          ], 8, _hoisted_148)), [
                                                            [_vModelSelect, dealProduct.customFieldValues[field.key || field.id]]
                                                          ])
                                                  ]))
                                                }), 128))
                                              : (customField.content.fields && Array.isArray(customField.content.fields))
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    _createElementVNode("div", _hoisted_151, [
                                                      _createElementVNode("h6", _hoisted_152, _toDisplayString(customField.content.name || _ctx.directT('crm.deals.form.customFields')), 1)
                                                    ]),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customField.content.fields, (field) => {
                                                      return (_openBlock(), _createElementBlock("div", {
                                                        key: field.id,
                                                        class: "space-y-1"
                                                      }, [
                                                        _createElementVNode("label", _hoisted_153, _toDisplayString(field.label) + _toDisplayString(field.required ? ' *' : ''), 1),
                                                        (field.type !== 'select' && field.type !== 'textarea')
                                                          ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                              key: 0,
                                                              type: _ctx.getInputType(field.type),
                                                              "onUpdate:modelValue": ($event: any) => ((dealProduct.customFieldValues[field.id]) = $event),
                                                              placeholder: field.placeholder || '',
                                                              class: "w-full px-3 py-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm"
                                                            }, null, 8, _hoisted_154)), [
                                                              [_vModelDynamic, dealProduct.customFieldValues[field.id]]
                                                            ])
                                                          : (field.type === 'textarea')
                                                            ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                                                key: 1,
                                                                "onUpdate:modelValue": ($event: any) => ((dealProduct.customFieldValues[field.id]) = $event),
                                                                placeholder: field.placeholder || '',
                                                                rows: "2",
                                                                class: "w-full px-3 py-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm resize-none"
                                                              }, null, 8, _hoisted_155)), [
                                                                [_vModelText, dealProduct.customFieldValues[field.id]]
                                                              ])
                                                            : _withDirectives((_openBlock(), _createElementBlock("select", {
                                                                key: 2,
                                                                "onUpdate:modelValue": ($event: any) => ((dealProduct.customFieldValues[field.id]) = $event),
                                                                class: "w-full px-3 py-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm"
                                                              }, [
                                                                _createElementVNode("option", _hoisted_157, _toDisplayString(_ctx.directT('crm.deals.form.selectOption')), 1),
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.options, (option) => {
                                                                  return (_openBlock(), _createElementBlock("option", {
                                                                    key: option,
                                                                    value: option
                                                                  }, _toDisplayString(option), 9, _hoisted_158))
                                                                }), 128))
                                                              ], 8, _hoisted_156)), [
                                                                [_vModelSelect, dealProduct.customFieldValues[field.id]]
                                                              ])
                                                      ]))
                                                    }), 128))
                                                  ], 64))
                                                : _createCommentVNode("", true)
                                          ], 64))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_159, " No content for customField " + _toDisplayString(customField.id), 1))
                                    ], 64))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_160, [
                _createElementVNode("div", _hoisted_161, [
                  _cache[58] || (_cache[58] = _createElementVNode("div", { class: "w-10 h-10 bg-gradient-to-br from-[#5856d6] to-[#af52de] rounded-xl flex items-center justify-center" }, [
                    _createElementVNode("i", { class: "material-symbols-outlined text-white text-lg" }, "settings")
                  ], -1)),
                  _createElementVNode("h3", _hoisted_162, _toDisplayString(_ctx.directT('crm.deals.form.actions')), 1)
                ]),
                _createElementVNode("div", _hoisted_163, [
                  _createElementVNode("button", {
                    type: "submit",
                    disabled: _ctx.loading,
                    class: "w-full px-6 py-3 bg-gradient-to-r from-[#5856d6] to-[#af52de] text-white font-medium rounded-2xl transition-all duration-200 hover:from-[#4338CA] hover:to-[#9333ea] disabled:opacity-50 disabled:cursor-not-allowed shadow-lg flex items-center justify-center gap-2"
                  }, [
                    (_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_165))
                      : (_openBlock(), _createElementBlock("i", _hoisted_166, "save")),
                    _createTextVNode(" " + _toDisplayString(_ctx.loading ? _ctx.directT('crm.deals.form.saving') : _ctx.directT('crm.deals.form.create')), 1)
                  ], 8, _hoisted_164),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.openProductsPopup && _ctx.openProductsPopup(...args))),
                    class: "w-full px-6 py-3 bg-gradient-to-r from-[#34C759] to-[#30D158] text-white font-medium rounded-2xl transition-all duration-200 hover:from-[#28A745] hover:to-[#28A745] shadow-lg flex items-center justify-center gap-2"
                  }, [
                    _cache[59] || (_cache[59] = _createElementVNode("i", { class: "material-symbols-outlined text-lg" }, "add_box", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.directT('ecommerce.addProducts') || 'Add Products'), 1)
                  ]),
                  _createVNode(_component_router_link, {
                    to: "/crm/deals",
                    class: "w-full px-6 py-3 bg-gradient-to-r from-[#dc2626] to-[#ef4444] text-white font-medium rounded-2xl transition-all duration-200 hover:from-[#b91c1c] hover:to-[#dc2626] border border-red-500 flex items-center justify-center gap-2"
                  }, {
                    default: _withCtx(() => [
                      _cache[60] || (_cache[60] = _createElementVNode("i", { class: "material-symbols-outlined text-lg" }, "close", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.directT('crm.deals.form.cancel')), 1)
                    ]),
                    _: 1,
                    __: [60]
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_167, [
              _createElementVNode("div", {
                ref: "sidebarRef",
                class: "bg-white dark:bg-[#1a1a1a] rounded-2xl shadow-lg border border-gray-200/50 dark:border-gray-700/50 p-6 z-10 transition-transform duration-100 ease-out",
                style: _normalizeStyle({ position: 'sticky', top: _ctx.sidebarTop + 'px' })
              }, [
                _createElementVNode("div", _hoisted_168, [
                  _cache[61] || (_cache[61] = _createElementVNode("div", { class: "w-10 h-10 bg-gradient-to-br from-[#5856d6] to-[#af52de] rounded-xl flex items-center justify-center" }, [
                    _createElementVNode("i", { class: "material-symbols-outlined text-white text-lg" }, "settings")
                  ], -1)),
                  _createElementVNode("h3", _hoisted_169, _toDisplayString(_ctx.directT('crm.deals.form.actions')), 1)
                ]),
                _createElementVNode("div", _hoisted_170, [
                  _createElementVNode("button", {
                    type: "submit",
                    disabled: _ctx.loading,
                    class: "w-full px-6 py-3 bg-gradient-to-r from-[#5856d6] to-[#af52de] text-white font-medium rounded-2xl transition-all duration-200 hover:from-[#4338CA] hover:to-[#9333ea] disabled:opacity-50 disabled:cursor-not-allowed shadow-lg flex items-center justify-center gap-2"
                  }, [
                    (_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_172))
                      : (_openBlock(), _createElementBlock("i", _hoisted_173, "save")),
                    _createTextVNode(" " + _toDisplayString(_ctx.loading ? _ctx.directT('crm.deals.form.saving') : _ctx.directT('crm.deals.form.create')), 1)
                  ], 8, _hoisted_171),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.openProductsPopup && _ctx.openProductsPopup(...args))),
                    class: "w-full px-6 py-3 bg-gradient-to-r from-[#34C759] to-[#30D158] text-white font-medium rounded-2xl transition-all duration-200 hover:from-[#28A745] hover:to-[#28A745] shadow-lg flex items-center justify-center gap-2"
                  }, [
                    _cache[62] || (_cache[62] = _createElementVNode("i", { class: "material-symbols-outlined text-lg" }, "add_box", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.directT('ecommerce.addProducts') || 'Add Products'), 1)
                  ]),
                  _createVNode(_component_router_link, {
                    to: "/crm/deals",
                    class: "w-full px-6 py-3 bg-gradient-to-r from-[#dc2626] to-[#ef4444] text-white font-medium rounded-2xl transition-all duration-200 hover:from-[#b91c1c] hover:to-[#dc2626] border border-red-500 flex items-center justify-center gap-2"
                  }, {
                    default: _withCtx(() => [
                      _cache[63] || (_cache[63] = _createElementVNode("i", { class: "material-symbols-outlined text-lg" }, "close", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.directT('crm.deals.form.cancel')), 1)
                    ]),
                    _: 1,
                    __: [63]
                  })
                ])
              ], 4)
            ])
          ])
        ], 32)
      ])
    ], 8, _hoisted_1),
    (_ctx.showProductsPopup)
      ? (_openBlock(), _createElementBlock("div", _hoisted_174, [
          _createElementVNode("div", _hoisted_175, [
            _createElementVNode("div", _hoisted_176, [
              _createElementVNode("div", _hoisted_177, [
                _cache[64] || (_cache[64] = _createElementVNode("div", { class: "w-10 h-10 bg-gradient-to-br from-[#5856d6] to-[#af52de] rounded-xl flex items-center justify-center" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined text-white text-lg" }, "inventory")
                ], -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("h3", _hoisted_178, _toDisplayString(_ctx.directT('crm.deals.form.selectProducts')), 1),
                  _createElementVNode("p", _hoisted_179, _toDisplayString(_ctx.directT('crm.deals.form.selectProductsForDeal')), 1)
                ])
              ]),
              _createElementVNode("button", {
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.closeProductsPopup && _ctx.closeProductsPopup(...args))),
                class: "p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors"
              }, _cache[65] || (_cache[65] = [
                _createElementVNode("i", { class: "material-symbols-outlined text-gray-500" }, "close", -1)
              ]))
            ]),
            _createElementVNode("div", _hoisted_180, [
              _createElementVNode("div", _hoisted_181, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.productSearchTerm) = $event)),
                  type: "text",
                  placeholder: _ctx.directT('crm.deals.form.searchProductsPlaceholder'),
                  class: "w-full px-4 py-3 pl-12 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm"
                }, null, 8, _hoisted_182), [
                  [_vModelText, _ctx.productSearchTerm]
                ]),
                _cache[66] || (_cache[66] = _createElementVNode("div", { class: "absolute left-4 top-1/2 -translate-y-1/2" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined text-gray-400 text-lg" }, "search")
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_183, [
              (_ctx.loadingProducts)
                ? (_openBlock(), _createElementBlock("div", _hoisted_184, [
                    _createElementVNode("div", _hoisted_185, [
                      _cache[67] || (_cache[67] = _createElementVNode("div", { class: "inline-block w-8 h-8 border-2 border-purple-500 border-t-transparent rounded-full animate-spin mb-4" }, null, -1)),
                      _createElementVNode("p", _hoisted_186, _toDisplayString(_ctx.directT('crm.deals.form.loadingProducts')), 1)
                    ])
                  ]))
                : (_ctx.filteredProducts.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_187, [
                      _createElementVNode("div", _hoisted_188, [
                        _cache[68] || (_cache[68] = _createElementVNode("i", { class: "material-symbols-outlined text-gray-400 text-4xl mb-4" }, "inventory", -1)),
                        _createElementVNode("p", _hoisted_189, _toDisplayString(_ctx.directT('crm.deals.form.noProductsFound')), 1)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_190, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredProducts, (product) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: product.id,
                          onClick: ($event: any) => (_ctx.toggleProductSelection(product)),
                          class: _normalizeClass(["border border-gray-200 dark:border-gray-700 rounded-xl p-4 cursor-pointer transition-all duration-200 hover:shadow-md", {
              'ring-2 ring-purple-500 bg-purple-50 dark:bg-purple-900/20': _ctx.selectedProducts.some(p => p.id === product.id),
              'hover:border-purple-300 dark:hover:border-purple-600': !_ctx.selectedProducts.some(p => p.id === product.id)
            }])
                        }, [
                          _createElementVNode("div", _hoisted_192, [
                            _createElementVNode("div", _hoisted_193, [
                              (product.image_link)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: product.image_link,
                                    alt: product.title,
                                    class: "w-full h-full object-cover"
                                  }, null, 8, _hoisted_194))
                                : (_openBlock(), _createElementBlock("div", _hoisted_195, _cache[69] || (_cache[69] = [
                                    _createElementVNode("i", { class: "material-symbols-outlined text-white text-lg" }, "inventory", -1)
                                  ])))
                            ]),
                            _createElementVNode("div", _hoisted_196, [
                              _createElementVNode("div", _hoisted_197, [
                                _createElementVNode("div", _hoisted_198, [
                                  _createElementVNode("h4", _hoisted_199, _toDisplayString(product.title), 1),
                                  (product.description)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_200, _toDisplayString(product.description), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_201, [
                                    _createElementVNode("span", _hoisted_202, _toDisplayString(_ctx.currencySymbol) + _toDisplayString(product.price || 0), 1),
                                    (product.compare_at_price && product.compare_at_price > (product.price || 0))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_203, _toDisplayString(_ctx.currencySymbol) + _toDisplayString(product.compare_at_price), 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", _hoisted_204, [
                                    (product.category)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_205, [
                                          _cache[70] || (_cache[70] = _createElementVNode("i", { class: "material-symbols-outlined text-xs" }, "category", -1)),
                                          _createTextVNode(" " + _toDisplayString(product.category), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (product.has_variants)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_206, [
                                          _cache[71] || (_cache[71] = _createElementVNode("i", { class: "material-symbols-outlined text-xs" }, "tune", -1)),
                                          _createTextVNode(" " + _toDisplayString(_ctx.directT('crm.deals.form.hasVariations')), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (product.customFields && product.customFields.length > 0)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_207, [
                                          _cache[72] || (_cache[72] = _createElementVNode("i", { class: "material-symbols-outlined text-xs" }, "settings", -1)),
                                          _createTextVNode(" " + _toDisplayString(_ctx.directT('crm.deals.form.customFields')), 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  (_ctx.selectedProducts.some(p => p.id === product.id))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_208, [
                                        _createElementVNode("label", _hoisted_209, _toDisplayString(_ctx.directT('crm.deals.form.quantityCardsToCreate')), 1),
                                        _createElementVNode("div", _hoisted_210, [
                                          _createElementVNode("button", {
                                            onClick: _withModifiers(($event: any) => (_ctx.updateProductQuantity(product.id, Math.max(1, (_ctx.productQuantities[product.id] || 1) - 1))), ["stop"]),
                                            class: "w-8 h-8 bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 rounded-lg flex items-center justify-center transition-colors"
                                          }, _cache[73] || (_cache[73] = [
                                            _createElementVNode("i", { class: "material-symbols-outlined text-sm" }, "remove", -1)
                                          ]), 8, _hoisted_211),
                                          _createElementVNode("input", {
                                            value: _ctx.productQuantities[product.id] || 1,
                                            onInput: ($event: any) => (_ctx.updateProductQuantity(product.id, parseInt(($event.target as HTMLInputElement).value) || 1)),
                                            onClick: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["stop"])),
                                            type: "number",
                                            min: "1",
                                            class: "w-16 px-2 py-1 text-center bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm"
                                          }, null, 40, _hoisted_212),
                                          _createElementVNode("button", {
                                            onClick: _withModifiers(($event: any) => (_ctx.updateProductQuantity(product.id, (_ctx.productQuantities[product.id] || 1) + 1)), ["stop"]),
                                            class: "w-8 h-8 bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 rounded-lg flex items-center justify-center transition-colors"
                                          }, _cache[74] || (_cache[74] = [
                                            _createElementVNode("i", { class: "material-symbols-outlined text-sm" }, "add", -1)
                                          ]), 8, _hoisted_213)
                                        ]),
                                        _createElementVNode("p", _hoisted_214, _toDisplayString(_ctx.directT('crm.deals.form.separateCardsWillBeCreated', { count: _ctx.productQuantities[product.id] || 1 })), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_215, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["w-6 h-6 rounded-full border-2 flex items-center justify-center transition-all duration-200", {
                           'border-purple-500 bg-purple-500': _ctx.selectedProducts.some(p => p.id === product.id),
                           'border-gray-300 dark:border-gray-600': !_ctx.selectedProducts.some(p => p.id === product.id)
                         }])
                                  }, [
                                    (_ctx.selectedProducts.some(p => p.id === product.id))
                                      ? (_openBlock(), _createElementBlock("i", _hoisted_216, "check"))
                                      : _createCommentVNode("", true)
                                  ], 2)
                                ])
                              ])
                            ])
                          ])
                        ], 10, _hoisted_191))
                      }), 128))
                    ]))
            ]),
            _createElementVNode("div", _hoisted_217, [
              _createElementVNode("div", _hoisted_218, [
                _createElementVNode("div", _hoisted_219, _toDisplayString(_ctx.directT('crm.deals.form.selectedProducts', { count: _ctx.selectedProducts.length })), 1),
                _createElementVNode("div", _hoisted_220, [
                  _createElementVNode("button", {
                    onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.closeProductsPopup && _ctx.closeProductsPopup(...args))),
                    class: "px-4 py-2 text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors"
                  }, _toDisplayString(_ctx.directT('crm.deals.form.cancel')), 1),
                  _createElementVNode("button", {
                    onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.addSelectedProducts && _ctx.addSelectedProducts(...args))),
                    disabled: _ctx.selectedProducts.length === 0,
                    class: "px-6 py-2 bg-gradient-to-r from-[#5856d6] to-[#af52de] text-white font-medium rounded-lg transition-all duration-200 hover:from-[#4338CA] hover:to-[#9333ea] disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
                  }, [
                    _cache[75] || (_cache[75] = _createElementVNode("i", { class: "material-symbols-outlined text-sm" }, "add", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.directT('crm.deals.form.addProducts', { count: _ctx.selectedProducts.length })), 1)
                  ], 8, _hoisted_221)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}